module.exports = __webpack_public_path__ + "assets/img/project-blob-right.6cefb21a.png";